var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"transparent"}},[_c('div',{},[_c('div',{staticClass:"neon-font",class:[_vm.foreColor, _vm.borderRadius],attrs:{"id":"neonclock"}},[_c('span',{staticClass:"bartime"},[_vm._v(_vm._s(_vm.hours)+":"+_vm._s(_vm.minutes)),_c('span',{staticClass:"barampm"},[_vm._v(_vm._s(_vm.ampm))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }